import DataStoreDispatcher from './DataStoreDispatcher';
import setMetaTags from './setMetaTags';
import readComponentInstanceResourceList from './readComponentInstanceResourceList';

export { DataStoreDispatcher, setMetaTags, readComponentInstanceResourceList };

export default {
  // WARNING: This is an experimental api (therefore marked private with
  // underscore prefix) that we could potentially use to allow fetching things
  // with more flexibility. This code is left here for demonstration purposes,
  // but further discussion is needed before we actually start using it.
  _read(componentInstance, axiosConfig = {}) {
    const {
      context: {
        flux
      }
    } = componentInstance;

    return flux.request(axiosConfig);
  }
};



// WEBPACK FOOTER //
// ./app/lib/frankly/index.js